<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pageInventories.title') }}
    </portal>
    <template v-if="inventories !== null">
      <tabable-card cols="12">
        <tabable-card-content :title="$t('admin.pageInventories.card.inventories')">
          <hm-card-inner :key="newInventoryKey">
            <template v-if="!isNil(newInventory)">
              <hm-multiselect id="roomNumbers"
                              v-model="newInventory.roomNumbers"
                              :options="hotelSettings.rooms.all()"
                              :label="$t('admin.pageInventories.roomNumbers')"
                              cols="12 6@tablet 3@desktop 2@hd start-1"
                              name="roomNumbers"
                              value-expression="roomNumber"
                              label-expression="${option.roomNumber}" />
              <hm-input-date ref="startDate"
                             v-model="newInventory.startDate"
                             :label="$t('admin.pageInventories.startDate')"
                             cols="12 2@hd 2@desktop 6@tablet"
                             name="startDate" />
              <hm-input-date ref="endDate"
                             v-model="newInventory.endDate"
                             :min-date="newInventory.startDate"
                             :min-date-inclusive="true"
                             :max-days="-1"
                             :label="$t('admin.pageInventories.endDate')"
                             max-date="20991231"
                             cols="12 2@hd 2@desktop 6@tablet"
                             name="endDate" />
              <hm-input-select id="type"
                               v-model="newInventory.type"
                               :label="$t('admin.pageInventories.type')"
                               :inline="true"
                               name="type"
                               cols="12 6@tablet 3@desktop 2@hd"
                               enum-name="InventoryCountType">
                <option :value="null">{{ $t(`pageRoomplan.actions.removeInventoryStatus`) }}</option>
              </hm-input-select>
              <hm-input id="remark"
                        v-model="newInventory.remark"
                        :label="$t('admin.pageInventories.remark')"
                        cols="12 6@tablet 3@desktop 3@hd"
                        name="remark"/>
              <hm-button :disabled="isEmpty(newInventory.roomNumbers)"
                         class="btn--blue"
                         icon-left="plus"
                         cols="12 6@tablet 2@desktop 1@hd"
                         @click="addInventory">
                {{ $t('admin.pageInventories.add') }}
              </hm-button>
            </template>
          </hm-card-inner>
          <hm-card-inner :full-size="true">
            <paginated-table :id="$attrs['id']"
                             :items-per-page="25"
                             :rows="futureInventory"
                             :hover="false"
                             columns="6"
                             grid-template-columns="2fr 2fr 2fr 2fr 3fr 1fr"
                             min-width="500px">
              <template slot="table-head">
                <div class="hm-table__th">{{ $t('admin.pageInventories.table.roomNumber') }}</div>
                <div class="hm-table__th">{{ $t('admin.pageInventories.table.startDate') }}</div>
                <div class="hm-table__th">{{ $t('admin.pageInventories.table.endDate') }}</div>
                <div class="hm-table__th">{{ $t('admin.pageInventories.table.type') }}</div>
                <div class="hm-table__th">{{ $t('admin.pageInventories.table.remark') }}</div>
                <div class="hm-table__th"></div>
              </template>
              <template v-slot:default="slotProps">
                <template v-for="row in slotProps.currentPage">
                  <div class="hm-table__td"><b>{{ row.roomNumber }}</b> ({{ getRoomTypeNameByRoomNumber(row.roomNumber) }})</div>
                  <div class="hm-table__td">{{ row.startDate | toLocalDate }}</div>
                  <div class="hm-table__td">{{ row.endDate | toLocalDate }}</div>
                  <div class="hm-table__td hm-table__td--input">
                    <hm-input-select id="type"
                                     v-model="row.type"
                                     :label="$t('admin.pageInventories.table.type')"
                                     :inline="true"
                                     name="type"
                                     enum-name="InventoryCountType" />
                  </div>
                  <div class="hm-table__td hm-table__td--input">
                    <hm-input id="remark"
                              v-model="row.remark"
                              :label="$t('admin.pageInventories.table.remark')"
                              :inline="true"
                              name="remark"/>
                  </div>
                  <div class="hm-table__td hm-table__td--icon">
                    <span class="quick-action-button" @click="deleteInventory(row.id)">
                      <icon icon="delete" />
                    </span>
                  </div>
                </template>
              </template>
            </paginated-table>
          </hm-card-inner>
        </tabable-card-content>
        <tabable-card-content :title="$t('admin.pageInventories.card.pastInventories')">
          <hm-card-inner :full-size="true">
            <paginated-table :id="$attrs['id']"
                             :items-per-page="25"
                             :rows="pastInventory"
                             :hover="false"
                             columns="6"
                             grid-template-columns="2fr 2fr 2fr 2fr 3fr 1fr"
                             min-width="500px">
              <template slot="table-head">
                <div class="hm-table__th">{{ $t('admin.pageInventories.table.roomNumber') }}</div>
                <div class="hm-table__th">{{ $t('admin.pageInventories.table.startDate') }}</div>
                <div class="hm-table__th">{{ $t('admin.pageInventories.table.endDate') }}</div>
                <div class="hm-table__th">{{ $t('admin.pageInventories.table.type') }}</div>
                <div class="hm-table__th">{{ $t('admin.pageInventories.table.remark') }}</div>
                <div class="hm-table__th"></div>
              </template>
              <template v-slot:default="slotProps">
                <template v-for="row in slotProps.currentPage">
                  <div class="hm-table__td">{{ row.roomNumber }}</div>
                  <div class="hm-table__td">{{ row.startDate | toLocalDate }}</div>
                  <div class="hm-table__td">{{ row.endDate | toLocalDate }}</div>
                  <div class="hm-table__td hm-table__td--input">{{ $t(`InventoryCountType.${row.type}`) }}</div>
                  <div class="hm-table__td hm-table__td--input">{{ row.remark }}</div>
                  <div class="hm-table__td hm-table__td--icon">
                    <span class="quick-action-button" @click="deleteInventory(row.id)">
                      <icon icon="delete" />
                    </span>
                  </div>
                </template>
              </template>
            </paginated-table>
          </hm-card-inner>
        </tabable-card-content>
      </tabable-card>
    </template>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { cloneDeep, first, groupBy, isEmpty, isEqual, isNil, keyBy, map, maxBy, pullAt, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import HmCardInner from '../../lib/layout/HmCardInner';
import HmMultiselect from '../../lib/inputs/HmMultiselect';
import HmButton from '../../lib/buttons/HmButton';
import uuid from 'uuid';
import TabableCard from '../../lib/layout/TabableCard';
import TabableCardContent from '../../lib/layout/TabableCardContent';

export default {
  name: 'PageInventories',
  components: { TabableCardContent, TabableCard, HmButton, HmMultiselect, HmCardInner },
  mixins: [HotelmeisterMixin, SaveWatchMixin],

  autosave: [
    {
      name: 'inventories',
      variable: 'inventories',
      fn: function (cbSaveComplete) {
        if (isNil(this.inventories)) {
          cbSaveComplete();
          return;
        }

        const inventories = cloneDeep(this.inventories);
        const savedInventoriesMap = isNil(this.savedInventories) ? {} : keyBy(this.savedInventories, 'id');

        inventories
          .filter((it) => {
            if (isNil(savedInventoriesMap[it.id])) return false;
            if (isEqual(savedInventoriesMap[it.id], it)) return false;
            return true;
          })
          .forEach((it) => {
            this.axios.put(this.serviceUrls.inventory.get(this, it.id), it)
              .then((response) => {
                this.showMessages(response);
              })
              .catch((error) => {
                this.showMessages(error.response);
              });
          });

        this.savedInventories = cloneDeep(inventories);

        cbSaveComplete();
      },
    },
  ],

  data() {
    return {
      newInventoryKey: null,
      newInventory: null,
      inventories: null,
      savedInventories: null,
    };
  },

  computed: {
    todaysDate() {
      return this.$moment().format('YYYYMMDD');
    },
    futureInventory() {
      return sortBy((this.inventories || []).filter(it => it.endDate >= this.todaysDate), ['startDate', 'roomNumber']);
    },
    pastInventory() {
      return sortBy((this.inventories || []).filter(it => it.endDate < this.todaysDate), ['startDate', 'roomNumber']);
    },
    roomNumberMap: function () {
      return keyBy(this.hotelSettings.rooms, 'roomNumber');
    },
  },

  watch: {
  },

  created: function () {
    this.initNewInventory();
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    isNil,
    loadData() {
      this.axios.get(this.serviceUrls.inventory.find(this, '20170101'))
        .then((response) => {
          this.__pauseAutosave('inventories');
          this.inventories = response.data.data;
          this.savedInventories = cloneDeep(this.inventories);
          this.__continueAutosave('inventories');
        });
    },
    addInventory() {
      const newInventory = cloneDeep(this.newInventory);

      if (isNil(newInventory)) return;

      const newInventories = newInventory.roomNumbers.map(it => ({
        roomNumber: it,
        startDate: newInventory.startDate,
        endDate: newInventory.endDate,
        type: newInventory.type,
        remark: newInventory.remark,
      }));

      const create = () => {
        if (isEmpty(newInventories)) return Promise.resolve();
        const toCreate = first(pullAt(newInventories, 0));

        return this.axios.post(this.serviceUrls.inventory.update(this), toCreate)
          .then((response) => {
            if (isEmpty(newInventories)) return Promise.resolve();
            return create();
          })
          .catch((error) => {
            this.showMessages(error.response);
          });
      };

      create()
        .then(() => {
          this.showSuccessMessage();
          this.initNewInventory();
          this.loadData();
        })
        .catch(() => {
          this.showErrorMessage();
        });
    },
    deleteInventory(inventoryId) {
      this.axios.delete(this.serviceUrls.inventory.get(this, inventoryId))
        .then((response) => {
          this.showSuccessMessage();
          this.loadData();
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    initNewInventory() {
      this.newInventory = {
        roomNumbers: [],
        startDate: this.$moment().format('YYYYMMDD'),
        endDate: this.$moment().add(1, 'days').format('YYYYMMDD'),
        type: 'ContractSold',
        remark: null,
      };
      this.newInventoryKey = uuid.v4();
    },
    getRoomTypeNameByRoomNumber(roomNumber) {
      try {
        return this.roomNumberMap[roomNumber].roomType.name[this.hotelSettings.details.primaryLanguage];
      } catch (e) {
        // should only happen if the room type doesn't exist any more
        return '-';
      }
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageInventory.vue